import NewHeader from 'components/NewHeader';
import { AboutCheckoutProduct } from 'components/About';
import BlogMainSection from 'components/Blog/BlogMainSection';
import { BlogMainVisual } from 'components/Blog/BlogMainVisual';
import { PageOuterContainer } from 'components/Common/CommonWrappers';
import FloatingController from 'components/Common/FloatingController';
import Footer from 'components/Footer/Footer';
import { BypassBlock } from 'components/Global';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';
import { NextSeo } from 'next-seo';
import bluedotMetaImg from 'public/asset/bluedot-metatag-img.png';

const Index = () => {
  const [$fakeHeaderRef, isFakeHeaderVisible, fakeHeaderEntry] = useInView({
    fallbackInView: true,
  });

  return (
    <BlogMainContainer>
      <NextSeo
        title="Blog - BLUEDOT"
        description="미디어 소식과 동영상 솔루션을 제공하는 블루닷의 기술과 노하우를 전합니다."
        canonical="https://blue-dot.io/blog/"
        openGraph={{
          url: 'https://blue-dot.io/blog/',
          title: 'Blog - BLUEDOT',
          description:
            '미디어 소식과 동영상 솔루션을 제공하는 블루닷의 기술과 노하우를 전합니다.',
          images: [
            {
              url: bluedotMetaImg.src,
              alt: 'BLUEDOT INC.',
              type: 'image/png',
            },
          ],
          siteName: 'BLUEDOT',
        }}
        twitter={{
          handle: '@handle',
          site: '@site',
          cardType: 'summary_large_image',
        }}
      />

      <BypassBlock contentSectionId="#blog-content1" />
      <div className="io-target" ref={$fakeHeaderRef} />

      {/* <Header isScrolled={!isFakeHeaderVisible && !!fakeHeaderEntry?.target} /> */}
      <NewHeader
        isScrolled={!isFakeHeaderVisible && !!fakeHeaderEntry?.target}
      />
      <BlogMainVisual />
      <BlogMainSection />
      <AboutCheckoutProduct />
      <Footer />

      <FloatingController isVisible={isFakeHeaderVisible} />
    </BlogMainContainer>
  );
};

export default Index;

const BlogMainContainer = styled(PageOuterContainer)`
  width: 100%;
`;
